/**
 * Fix: clear day-level active states when switching weeks in the itinerary block.
 *
 * The plugin's activateWeek() only deactivates week panes but leaves
 * day tabs/panes with .itinerary-active, causing stale content to show
 * when navigating between weeks.
 */
(function () {
  'use strict';

  var container = document.querySelector('.itinerary-tabs-container');
  if (!container) return;

  container.querySelectorAll('.itinerary-week-tab').forEach(function (weekTab) {
    weekTab.addEventListener('click', function () {
      // Clear all day-level active states across every week
      container.querySelectorAll('.itinerary-day-tab.itinerary-active').forEach(function (el) {
        el.classList.remove('itinerary-active');
      });
      container.querySelectorAll('.itinerary-day-pane.itinerary-active').forEach(function (el) {
        el.classList.remove('itinerary-active');
      });
    }, true); // capture phase — fires before the plugin's handler
  });

  /**
   * Detect overflowing description text and toggle the fade overlay class.
   * Runs on load and whenever a day tab or accordion is activated.
   */
  function checkOverflow() {
    container.querySelectorAll('.itin-day__desc-wrap').forEach(function (wrap) {
      var desc = wrap.querySelector('.itin-day__desc');
      if (!desc) return;
      if (desc.scrollHeight > wrap.clientHeight + 2) {
        wrap.classList.add('--has-overflow');
      } else {
        wrap.classList.remove('--has-overflow');
      }
    });
  }

  // Run after images load for accurate measurement
  window.addEventListener('load', checkOverflow);

  // Re-check when day tabs or accordion headers are clicked (content becomes visible)
  container.addEventListener('click', function (e) {
    if (e.target.closest('.itinerary-day-tab, .itinerary-week-tab, .day-accordion-header')) {
      setTimeout(checkOverflow, 50);
    }
  });
})();
